import React from 'react'
import StructuredData from './StructuredData'
import { getVideoObjectData } from './VideoObjectStructuredData'

const getVideoObjects = (sections) => {
  return (
    sections?.flatMap((section) => {
      return section.items.map((session) => {
        return getVideoObjectData(session)
      })
    }) || []
  )
}

export const getCreativeWorkSeriesData = (data, userLocale) => {
  return {
    '@type': 'CreativeWorkSeries',
    name: data.title,
    description: data.description,
    url: data.url,
    image: data.image?.url,
    inLanguage: data.locale || userLocale,
    sameAs: data.socialAccounts?.map((account) => account.urlOrHandle.trim()),
    hasPart: getVideoObjects(data.sections),
  }
}

export default function CreativeWorkSeriesStructuredData({ data }) {
  if (!data || Object.keys(data).length === 0) return null
  const structuredData = getCreativeWorkSeriesData(data)

  return <StructuredData data={structuredData} dataTestId="creative-work-series-structured-data" />
}
